<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}
			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>



		<label>
			{{ 'Level' | translate }}
			<select required :value="config.options.type" @change="onChangeType" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in multiplyType" :key="index">
					{{ digit.label | translate }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>

			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>

		<template v-if="config.options.type === 'multiply' ||
			config.options.type === 'multiply_50_100'
		">
			<label>
				{{ 'Complexity' | translate }}
				<select required v-model="config.options.places" class="form-control">
					<option :value="difficult" v-for="(difficult, index) in config.options.type === 'multiply'
						? difficult
						: baseDifficult" :key="index">
						{{ difficult }}
					</option>
				</select>
			</label>

			<label v-if="config.options.type === 'multiply'">
				{{ 'Digit' | translate }}
				<Multiselect :class="numbersError && 'multiselect-error'" placeholder="" :multiple="true" :required="true"
					v-model="config.options.numbers" :options="digits" :custom-label="customLabels" />

			</label>

			<label v-if="config.options.type === 'multiply_50_100'">
				{{ 'Digit' | translate }}

				<select required v-model="config.options.option" class="form-control">
					<option selected value="more_than_digit">
						>
					</option>

					<option value="less_than_digit">
						&lt;
					</option>

					<option value="universal">
						=/
					</option>
				</select>
			</label>


		</template>

		<template v-else-if="config.options.type === 'multiply_quad'">
			<label>
				{{ 'Digit' | translate }}
				<select required v-model="config.options.numbers" class="form-control">
					<option :value="number.value" v-for="(number, index) in quadNumbers" :key="index">
						{{ number.label }}
					</option>
				</select>
			</label>
		</template>

		<template>
			<label>
				{{ 'Number of expressions' | translate }}
				<input type="number" :value="config.repeat" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10"
					step="1" class="form-control" />
			</label>
		</template>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

import {
	DEFAULT_MULTIPLY_OPTIONS,
	DEFAULT_MULTIPLY_BASE_OPTIONS,
	DEFAULT_MULTIPLY_QUAD_OPTIONS,
	DEFAULT_MULTIPLY_25X25_OPTIONS,
} from '../Create.vue'

export default {
	name: 'multiply',
	data: () => ({ numbersError: false }),
	components: {
		Multiselect,
	},
	props: {
		config: Object,
		onInputRepeat: Function,
		onBlurRepeat: Function,
		gameTypes: Array,
	},
	created() {
		// if (this.config.id || this.config.is_created) {
		// 	this.config.id = undefined

		// 	if ((this.config.options.type && !this.config.options.type.includes('multiply') || this.config.options.calculation_method)) {
		// 		this.config.options = { ...DEFAULT_MULTIPLY_OPTIONS }
		// 	}
		// } else {
		// 	// small super-fast fix for make new config object
		// 	this.config.options = { ...DEFAULT_MULTIPLY_OPTIONS }
		// }

		// this.config.is_created = true

		// if (this.config.id) {
		// 	this.config.id = undefined
		// } else {
		// 	this.config.options = { ...DEFAULT_MULTIPLY_OPTIONS }
		// }
	},
	computed: {
		multiplyType: () => [
			{ value: 'multiply', label: 'Multiplication' },
			{ value: 'multiply_quad', label: 'Squared' },
			{ value: 'multiply_50_100', label: 'Base 50/100' },
			{ value: 'multiply_25x25', label: '25x25' },
		],

		difficult: () => [1, 10, 100, 1000],
		baseDifficult: () => [50, 100],

		digits: () => [
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			19,

			10,
			20,
			30,
			40,
			50,
			60,
			70,
			80,
			90,
			// 100,
		],
		quadNumbers: () => [
			{ label: '11-19', value: [11, 19] },
			{ value: [20, 29], label: '20-29' },
			{ value: [30, 70], label: '30-70' },
			{ value: [80, 120], label: '80-120' },
		],
	},
	methods: {
		validate() {
			if (this.config.options.numbers && this.config.options.numbers.length) {
				this.numbersError = false
			} else {
				this.numbersError = true
			}
		},
		onChangeType({ target: { value } }) {
			this.config.options.type = value
			switch (this.config.options.type) {
				case 'multiply_quad':
					this.config.options = { ...DEFAULT_MULTIPLY_QUAD_OPTIONS }
					break
				case 'multiply':
					this.config.options = { ...DEFAULT_MULTIPLY_OPTIONS }
					break
				case 'multiply_50_100':
					this.config.options = { ...DEFAULT_MULTIPLY_BASE_OPTIONS }
					break
				case 'multiply_25x25':
					this.config.options = { ...DEFAULT_MULTIPLY_25X25_OPTIONS }
					break
			}
		},

		customLabels(option) {
			const labels = {
				10: '10-19',
				20: '20-29',
				30: '30-39',
				40: '40-49',
				50: '50-59',
				60: '60-69',
				70: '70-79',
				80: '80-89',
				90: '90-99',
			}

			return labels[option] ? labels[option] : option
		},
	},
}
</script>

<style lang="scss">
.multiselect span {
	color: #495057 !important;
}

.multiselect__tag {
	border: 1px solid #5DCF3C !important;

	background-color: rgba(#E8FFE1, 0.4) !important;
}
</style>

<style scoped>
.not-equal::before {
	content: '\2260';

	margin: 0 4px;

	font-family: 'Times New Roman', Times, serif;
}
</style>
